// extracted by mini-css-extract-plugin
module.exports = {"error-code":"twigError_error-code__S506S","error-wrapping-box":"twigError_error-wrapping-box__1z6yP"};